<template>
  <transition name="fade" mode="out-in" :class="['repeatableGroup', definition.id, {'repeatableGroupWithIcon': repeatableGroupIcon}]">
    <div>
      <div v-if="!definitionBuilder && (/*isEditable(definition, null) || */draggableObject.children.length > 0)" class="toggle_accordion" @click="accordion()">
        <!--<div v-if="repeatableGroupIcon && repeatableGroupIcon" class="repeatableGroupIcon">
          <i :class="[repeatableGroupIcon]"></i>
        </div>-->
        <!--<span>{{ definition.label }} ({{ draggableObject.children.length }})</span>-->
        <span>{{ getLang('added') }}: {{ draggableObject.children.length }}</span>
        <i :class="['icon_toggle', 'fa', 'fa-angle-down', {'rotate180': repeatableGroupOpen}]"></i>
      </div>

      <!-- Repeatable timeline presentation -->
      <definition-repeatable-timeline v-if="timeline"
        :definition="definition"
        :object="object"
        :id="definitionId"
        :visualDefinition="visualDefinition"
        :definitionContentId="definitionContentId"
        :languageSelected="languageSelected"
        :language="language"
        :authorization="authorization"
        :type="type"
        :visuals="visuals"
        :apiparams="apiparams"
        :repeatableGroupPresentation="repeatableGroupPresentation"
        :class="[
          'w3-container',
          'w3-animate-opacity',
          {'w3-show': repeatableGroupOpen},
          {'w3-hide': !repeatableGroupOpen}
        ]"
        :callTask="callTask"
        @refreshDefinitionContent="refreshDefinitionContent"
        @taskLink="taskLink"
      />

      <!-- for definition 'builder' presentation -->
      <definition-builder v-else-if="definitionBuilder"
        :definition="definition"
        :object="object"
        :languageSelected="languageSelected"
        :language="language"
        :apiparams="apiparams"
        :definitionId="definitionId"
        :definitionContentId="definitionContentId"
        :repeatableGroupCode="getDefinitionBuilderCode()"
        :visualDefinition="visualDefinition"
        :questions="getDefinitionQuestions()"
        :authorization="authorization"
        :type="type"
        :visuals="visuals"
        @newLanguageSelected="newLanguageSelected"
        @refreshDefinitionContent="refreshDefinitionContent"
        @taskLink="taskLink"
        @editingQuestion="editingQuestion"
      />

      <definition-repeatable-list v-else-if="repeatableList"
        :draggableObject="draggableObject"
        :definition="definition"
        :object="object"
        :requestObjectForAddModified="requestObjectForAddModified"
        :languageSelected="languageSelected"
        :language="language"
        :apiparams="apiparams"
        :definitionId="definitionId"
        :definitionContent="definitionContent"
        :definitionContentId="definitionContentId"
        :visualDefinition="visualDefinition"
        :authorization="authorization"
        :type="type"
        :visuals="visuals"
        :repeatableGroupOpen="repeatableGroupOpen"
        :repeatableGroupCode="repeatableGroupCode"
        :validateModifyForm="validateModifyForm"
        :repeatableGroupPresentation="repeatableGroupPresentation"
        :callTask="callTask"
        :route="route"
        :codeLoaded="codeLoaded"
        :definitionMultiLanguageGroup="definitionMultiLanguageGroup"
        :hideAdd="hideAdd"
        :hideModify="hideModify"
        :removeIndex="removeIndex"
        :modify="modify"
        :modifyIndex="modifyIndex"
        @newLanguageSelected="newLanguageSelected"
        @refreshDefinitionModifying="refreshDefinitionModifying"
        @conditionalDefinitionChange="conditionalDefinitionChange"
        @refreshDefinitionContent="refreshDefinitionContent"
        @refreshConditionalFieldId="refreshConditionalFieldId"
        @refreshDefinition="refreshDefinition"
        @removeItem="removeItem"
        @modifyItem="modifyItem"
        @okModify="okModify"
        @cancelModify="cancelModify"
      />

      <!-- Repeatable draggable presentation -->
      <div v-else-if="draggableObject.children.length > 0">
        <div v-show="modify" class="fade-modify-container" key="fadeModify"></div>
        <draggable
          v-model="draggableObject.children"
          v-bind="{'disabled':(type.modeView === 'lookup' || modify || hideAdd)}"
          :class="[
            'w3-container',
            'w3-animate-opacity',
            'draggable',
            {'repeatableGroupWithIcon': repeatableGroupIcon},
            {'w3-show': repeatableGroupOpen},
            {'w3-hide': !repeatableGroupOpen}
          ]"
          :key="draggableObject.children.length"
          @sort="sortObject"
        >
          <transition-group name="fade" mode="out-in">
            <!-- repeateble group items -->
            <div
              v-for="(obj, objIndex) in draggableObject.children" :key="obj.id + '_' + objIndex"
              :class="['list-complete-item', 'w3-display-container', {'sortable':!modify && type.modeView !== 'lookup' && !hideAdd},
                getRepeatableGroupPresentationClass(), {'modifying': modify && modifyIndex === objIndex},
                {'disabled': modify && modifyIndex !== objIndex}, {'action-task': isActionTask()}
              ]"
              @click="itemClicked(objIndex)"
            >
              <div :class="['w3-display-topright', 'buttons', {'modify': modify && modifyIndex === objIndex}]">
                <div class="w3-display-topleft code">
                  {{ objIndex + 1 }}. <span class="title-value">{{ getRepeatableGroupTitle(objIndex) }}</span> <span class="code-value">{{ getRepeatableGroupCode(objIndex) }}</span>
                </div>
                <div class="language-buttons">
                  <template v-if="(route && route.query && route.query.code && !codeLoaded)">
                    <spinner-loading class="spinner-loading codeLoading" :line-size='2' :size='18' line-fg-color='#5dbecd' />
                  </template>
                  <template v-else>
                    <!-- multilanguage select -->
                    <definition-multilanguage v-if="!modify && definitionMultiLanguageGroup"
                      :definition="definitionMultiLanguageGroup" :object="object" :languageSelected="languageSelected" :language="language" :apiparams="apiparams"
                      @newLanguageSelected="newLanguageSelected"
                    />

                    <!-- remove button -->
                    <template v-if="!modify">
                      <button v-show="modifyIndex !== objIndex && !hideAdd && isEditable(definition, obj)" class="remove-item" @click="removeItem(objIndex)" v-tooltip="{content: getLang('delete'), delay: { show: 400, hide: 100 }}">
                        <transition name="fade" mode="out-in">
                          <span v-if="removeIndex !== objIndex"><i class="sherpa-icon icon-trash"></i></span>
                          <spinner-loading v-else class="spinner-loading" :size="19" :line-size="1" line-fg-color='#5dbecd' />
                        </transition>
                      </button>
                      <!-- modify button -->
                      <button v-show="!hideModify" class="modify-item" @click="modifyItem(obj, objIndex)" v-tooltip="{content: getLang('edit'), delay: { show: 400, hide: 100 }}">
                        <transition name="fade" mode="out-in">
                          <span v-if="modifyIndex !== objIndex"><i class="sherpa-icon icon-editar"></i></span>
                          <spinner-loading v-else class="spinner-loading" :size="18" :line-size="1" line-fg-color='#5dbecd' />
                        </transition>
                      </button>
                    </template>

                    <!-- modify button -->
                    <template v-if="modify && modifyIndex === objIndex && isEditable(definition, obj)">
                      <button class="modify-item ok" @click="okModify($event)">
                        <transition name="fade" mode="out-in">
                          <span v-if="!validateModifyForm.validatingAdd"><i class="far fa-save"></i> {{ getLang('update') }}</span>
                          <spinner-loading v-else class="spinner-loading" :size="18" :line-size="1" line-fg-color='#5dbecd' />
                        </transition>
                      </button>
                    </template>
                  </template>
                </div>
              </div>
              <transition name="fade" mode="out-in">
                <!-- Repeatable group element -->
                <div v-if="(!modify || modifyIndex !== objIndex)" :class="['complete-item', {'w3-hide': !repeatableGroupPresentation.alias || repeatableGroupPresentation.alias.length === 0 }]">
                  <div
                    v-for="(childObj, childObjIndex) in obj.children" :key="childObjIndex"
                    v-if="getRequestObjectByIdAndIndex(childObj.id, objIndex) && getRequestDefinition(childObj.id).type !== 'code'"
                    :class="[childObj.id, 'subitem', {'pulse': isLanguageSelected(childObj.id)},
                    {'w3-hide': !validateQuestFlow(definition, obj, childObj.id)}]"
                  >
                    <definition-repeatable-group-read-only
                      :definitionId="definitionId" :definition="getRequestDefinitionById(childObj.id)" :object="getRequestObjectByIdAndIndex(childObj.id, objIndex)"
                      :languageSelected="languageSelected" :index="objIndex" :moment="getMoment()" :showMultilanguage="false" :language="language"
                      :visualDefinition="visualDefinition" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
                      :definitionContentId="definitionContentId" :repeatableGroupCode="getRepeatableGroupCode(objIndex)" :repeatableGroupPresentation="repeatableGroupPresentation" @newLanguageSelected="newLanguageSelected"
                    />
                  </div>
                </div>
                <!-- Editing repeatable group element -->
                <div v-else class="slot">
                  <button class="modify-item cancel" @click="cancelModify($event)">
                    <transition name="fade" mode="out-in">
                      <span v-if="!validateModifyForm.validatingAdd"><i class="sherpa-icon icon-cerrar"></i></span>
                    </transition>
                  </button>
                  <simplebar data-simplebar-auto-hide="false">
                    <div class="inner-slot">
                      <!-- Modify definition -->
                      <definition-obj v-for="reqDef in definition.children" :key="reqDef.id"
                        :id="reqDef.id"
                        :definitionId="definitionId"
                        :reqDef="reqDef"
                        :reqObj="getRequestObjectByIdAndIndex(reqDef.id, objIndex, true)"
                        :reqObjForAdd="object.children[objIndex]"
                        :requestObjectForAddModified="requestObjectForAddModified"
                        :content="definitionContent"
                        :modeView="getRepeatableGroupModeView(obj)"
                        :validateAddForm="validateModifyForm"
                        :repeatableGroupId="repeatableGroupId"
                        :languageSelected="languageSelected"
                        :index="objIndex"
                        :moment="getMoment()"
                        :definitionContentId="definitionContentId"
                        :parentRepeatableGroupCode="getRepeatableGroupCode(objIndex)"
                        :language="language"
                        :visualDefinition="visualDefinition"
                        :authorization="authorization"
                        :type="type"
                        :visuals="visuals"
                        :apiparams="apiparams"
                        :editingRepeatable="true"
                        @newLanguageSelected="newLanguageSelected"
                        @refreshDefinition="refreshDefinitionModifying"
                        @conditionalDefinitionChange="conditionalDefinitionChange"
                        @refreshDefinitionContent="refreshDefinitionContent"
                        @refreshConditionalFieldId="refreshConditionalFieldId"
                        @formAddSaved="formAddSaved"
                        class="item"
                      />

                      <!-- Definition Group Task Edit -->
                      <div v-if="definition.task && definition.task.length > 0" :class="[getDefinitionFieldClassTaskClass(), 'groupTasks']">
                        <definition-task
                          :definition="definition" :object="getRequestObjectByIdAndIndex(definition.id, objIndex)" :definitionContentId="definitionContentId" :repeatableGroupCode="getRepeatableGroupCode(objIndex)" :languageSelected="languageSelected" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
                          location="edit" :repeatableGroupPresentation="repeatableGroupPresentation" :callTask="callTask"
                          @refreshDefinition="refreshDefinition" @refreshDefinitionContent="refreshDefinitionContent"
                        />
                      </div>
                    </div>
                  </simplebar>
                </div>
              </transition>

              <!-- Definition Group Task Presentation -->
              <div v-if="definition.task && definition.task.length > 0" :class="[getDefinitionFieldClassTaskClass(), 'groupTasks']">
                <definition-task
                  :definition="definition" :object="getRequestObjectByIdAndIndex(definition.id, objIndex)" :definitionContentId="definitionContentId" :repeatableGroupCode="getRepeatableGroupCode(objIndex)" :languageSelected="languageSelected" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
                  location="presentation" :repeatableGroupPresentation="repeatableGroupPresentation" :repeatableItemIndex="objIndex" :calledTaskIndex="calledTaskIndex"
                  :editRepeatableWaitProcess="isEditRepeatableWaitProcess(objIndex)" :callTask="callTask"
                  @refreshDefinition="refreshDefinition" @refreshDefinitionContent="refreshDefinitionContent"
                  @waitingProcessFinished="waitingProcessFinished" @waitingProcessInit="waitingProcessInit"
                />
              </div>
            </div>
          </transition-group>
        </draggable>
      </div>
    </div>
  </transition>
</template>

<script>
import DefinitionRepeatableTimeline from './repeatableTimeline'
import DefinitionRepeatableGroupReadOnly from './repeatableGroupReadOnly'
import DefinitionRepeatableList from './repeatableList'
import DefinitionMultilanguage from '../multilanguage'
import DefinitionTask from '../task'
import draggable from 'vuedraggable'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'
import language from '../../language'
import DefinitionBuilder from './definitionBuilder'
import vueNiceScrollbar from 'vue-nice-scrollbar'
import simplebar from 'simplebar-vue'

import 'simplebar/dist/simplebar.min.css'

export default {
  name: 'definition-repeatable-group',
  props: [
    'definition',
    'object',
    'modeView',
    'definitionId',
    'definitionContent',
    'repeatableGroupId',
    'languageSelected',
    'definitionContentId',
    'repeatableGroupCode',
    'timeline',
    'definitionBuilder',
    'repeatableList',
    'language',
    'visualDefinition',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'formAddRemoved',
    'hideAdd',
    'hideModify',
    'callTask'
  ],
  data () {
    return {
      draggableObject: null,
      modify: false,
      remove: false,
      modifyIndex: -1,
      removeIndex: -1,
      objBackup: null,
      formModifyErrors: 0,
      validateModifyForm: {
        repeatableGroupId: null,
        validatingAdd: false,
        timeEventAdd: null
      },
      languageChanged: false,
      repeatableGroupPresentation: null,
      definitionMultiLanguageGroup: null,
      repeatableGroupIcon: null,
      repeatableGroupOpen: true,
      requestObjectForAddModified: {
        ts: null
      },
      calledTaskIndex: {
        ts: null,
        index: -1
      },
      codeLoaded: false,
      code: null,
      route: null
    }
  },
  components: {
    draggable,
    vueNiceScrollbar,
    DefinitionRepeatableGroupReadOnly,
    DefinitionRepeatableTimeline,
    DefinitionRepeatableList,
    DefinitionMultilanguage,
    DefinitionTask,
    DefinitionBuilder,
    simplebar,
    DefinitionObj: () => import('../definitionObj.vue') // Webpack’s asynchronous import for recursivity components
  },
  beforeMount () {
    this.initRepeatableGroup()
  },
  mounted () {
    if (this.route && this.route.query && this.route.query.code) {
      if (this.draggableObject && this.draggableObject.children) {
        var obj = null
        var objIndex = null
        for (var i = 0; i < this.draggableObject.children.length && !objIndex; i++) {
          if (this.route.query.code === this.getRepeatableGroupCode(i)) {
            obj = this.draggableObject.children[i]
            objIndex = i
          }
        }
        if (obj) {
          this.codeLoaded = true
          this.modifyItem(obj, objIndex)
        }
      }
    }
  },
  methods: {
    initRepeatableGroup () {
      this.route = this.$route
      this.modify = false
      this.modifyIndex = -1
      this.objBackup = null
      this.formModifyErrors = 0
      this.validateModifyForm = {
        repeatableGroupId: null,
        validatingAdd: false,
        timeEventAdd: null
      }
      this.repeatableGroupPresentation = this.visualDefinition.getRepeatableGroupPresentation(this.definition.id)
      if (this.repeatableGroupPresentation) {
        if (this.repeatableGroupPresentation.openByDefault !== undefined && !this.repeatableGroupPresentation.openByDefault) {
          this.repeatableGroupOpen = false
        }
      }
      this.definitionMultiLanguageGroup = transport.methods.definitionMultiLanguageGroup([this.definition])
      this.getDefinitionFieldIcon()
      this.setDraggableObject(this.object)
    },
    getRepeatableGroupPresentationClass () {
      var result = 'w3-col'
      if (this.repeatableGroupPresentation && this.repeatableGroupPresentation.class) {
        result = this.repeatableGroupPresentation.class
      }
      return result
    },
    accordion () {
      this.repeatableGroupOpen = !this.repeatableGroupOpen
    },
    getDefinitionFieldClassTaskClass () {
      var definition = this.visualDefinition.getDefinitionFields(this.definition.id)
      return definition.tasks
    },
    getRequestDefinitionById (id) {
      return transport.methods.getRequestDefinitionById(id, [this.definition])
    },
    sortObject () {
      this.$emit('repeatableGroupModified', this.draggableObject, true)
    },
    isEditable (definition, repeatableObject) {
      let result = false

      if (repeatableObject && repeatableObject.editable === false) {
        result = false
      } else {
        result = false

        if (definition.children) {
          for (var i = 0; i < definition.children.length && !result; i++) {
            result = result || transport.methods.isEditable(this.modeView, definition.children[i], repeatableObject)
            if (!result) {
              result = result || this.isEditable(definition.children[i], repeatableObject)
            }
          }
        }
      }
      return result
    },
    removeItem (index) {
      if (!this.remove) {
        this.remove = true
        this.removeIndex = index
        this.code = this.getRepeatableGroupCode(index)

        // Dialog
        let message = this.getLang('formConfirmDelete')
        let options = {
          okText: this.getLang('delete'),
          cancelText: this.getLang('cancel'),
          customClass: 'sherpaDialog'
        }
        if (this.$dialog) {
          this.$dialog.confirm(message, options)
            .then(() => {
              if (this.code) {
                this.$emit('removingAddForm', this.code, this.definition.id)
              }
              this.draggableObject.children.splice(this.removeIndex, 1)
              this.resetModify(true, false)
            })
            .catch(() => {
              this.resetModify(false, false)
            })
        } else {
          if (this.code) {
            this.$emit('removingAddForm', this.code, this.definition.id)
          }
          this.draggableObject.children.splice(this.removeIndex, 1)
          this.resetModify(true, false)
        }
      }
    },
    modifyItem (obj, index) {
      if (!this.modify) {
        this.modifyIndex = index
        this.objBackup = JSON.parse(JSON.stringify(obj))
        this.code = this.getRepeatableGroupCode(index)

        // check if we have a waitingProcess task
        if (!this.hasWaitingProcessTask()) {
          this.modify = true
          this.$emit('modifyingAddForm', this.code)
        }
      }
    },
    isEditRepeatableWaitProcess (index) {
      return this.hasWaitingProcessTask() && index === this.modifyIndex
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    waitingProcessFinished (result, code) {
      if (result) {
        this.code = code
        this.modify = true
        this.$emit('modifyingAddForm', this.code)
      } else {
        this.resetModify(false, false)
      }
    },
    waitingProcessInit () {
      this.$emit('waitingProcessInit')
    },
    hasWaitingProcessTask () {
      var found = false
      if (this.definition.task) {
        for (var i = 0; i < this.definition.task.length && !found; i++) {
          var task = this.definition.task[i]
          found = (task.type && task.type.id === 'waitingProcess')
        }
      }
      return found
    },
    getRequestObjectByIdAndIndex (id, index, fromModify) {
      return transport.methods.getRequestObjectById(id, [this.object.children[index]])
    },
    cancelModify (event) {
      // check not Intro key
      if (event.layerX >= 0 && event.layerY >= 0) {
        this.draggableObject.children[this.modifyIndex] = this.objBackup
        this.resetModify(false, false)
      }
    },
    okModify (event) {
      // check not Intro key
      if (event.layerX >= 0 && event.layerY >= 0) {
        if (!this.validateModifyForm.validatingAdd) {
          this.checkModifyForm()
        }
      }
    },
    checkModifyForm () {
      // change validateModifyForm / watcher waiting for fields validation...
      this.activateValidatingModifyForm()

      var self = this
      setTimeout(function () {
        var errors = transport.methods.validateForm(self.modeView, [self.definition], [self.object.children[self.modifyIndex]], true)
        self.formModifyErrors = errors.errorsNumber
        if (self.formModifyErrors === 0) {
          // No errors on fields. Let's add to repeatable group.
          self.resetModify(true, true)

          // Errors on fields.
        } else {
          self.errorModifyForm(self.formModifyErrors)
          self.deactivateValidatingModifyForm()
        }
      }, 500)
    },
    resetModify (refreshContentObject, callUpdate) {
      this.modify = false
      this.modifyIndex = -1
      this.remove = false
      this.removeIndex = -1
      this.objBackup = null
      this.formModifyErrors = 0
      this.deactivateValidatingModifyForm()
      this.$emit('errorModifyForm', this.formModifyErrors)

      if (refreshContentObject) {
        this.$emit('repeatableGroupModified', this.draggableObject, callUpdate, this.code)
      } else {
        this.$emit('repeatableGroupModified', null, callUpdate)
      }
    },
    activateValidatingModifyForm () {
      this.validateModifyForm = {
        repeatableGroupId: this.repeatableGroupId,
        validatingAdd: true,
        timeEventAdd: moment().valueOf()
      }
    },
    deactivateValidatingModifyForm () {
      this.validateModifyForm = {
        repeatableGroupId: null,
        validatingAdd: false,
        timeEventAdd: moment().valueOf()
      }
    },
    errorModifyForm (formModifyErrors) {
      this.$emit('errorModifyForm', formModifyErrors)
    },
    getRequestDefinition (id) {
      var reqDef = transport.methods.getRequestDefinitionById(id, [this.definition])
      return reqDef
    },
    isLanguageSelected (reqDefId) {
      var reqDef = this.getRequestDefinition(reqDefId)
      return transport.methods.isMultiLanguage(reqDef) && this.languageChanged
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    getMoment () {
      return moment().valueOf()
    },
    getRepeatableGroupCode (index) {
      var reqObj = this.getRequestObjectByIdAndIndex(this.definition.id, index)
      return transport.methods.getRepeatableGroupCode(reqObj, this.definition)
    },
    getRepeatableGroupTitle (index) {
      var result = ''
      if (this.repeatableGroupPresentation && this.repeatableGroupPresentation.title) {
        var lang
        if (this.languageSelected) {
          lang = this.languageSelected.key
        }
        var reqDef = transport.methods.getRequestDefinitionById(this.repeatableGroupPresentation.title, [this.definition])
        var reqObj = this.getRequestObjectByIdAndIndex(this.repeatableGroupPresentation.title, index)
        result = transport.methods.getObjectTextValue(null, reqDef, reqObj, lang)
      }
      return result
    },
    refreshDefinition (object) {
      this.$emit('refreshDefinition', object)
    },
    refreshDefinitionModifying (object) {
      if (object && this.modifyIndex > -1) {
        this.object.children[this.modifyIndex] = transport.methods.changeRequestObject(object.id, this.object.children[this.modifyIndex], object)
        this.requestObjectForAddModified.ts = moment().valueOf()
      }
    },
    getDefinitionFieldIcon () {
      var definition = this.visualDefinition.getDefinitionFields(this.definition.id)
      this.repeatableGroupIcon = definition.icon
    },
    conditionalDefinitionChange (conditionalFieldId, newReqObj) {
      if (this.modifyIndex > -1) {
        transport.methods.changeConditionalObjects(this.object.children[this.modifyIndex].children, conditionalFieldId, newReqObj)
      }
    },
    refreshConditionalFieldId (newReqObj) {
      if (this.object.children[this.modifyIndex].children && newReqObj) {
        for (var i = 0; i < newReqObj.length; i++) {
          var obj = newReqObj[i]
          var found = false
          for (var j = 0; j < this.object.children[this.modifyIndex].children.length && !found; j++) {
            var childObj = this.object.children[this.modifyIndex].children[j]
            if (obj.id === childObj.id) {
              childObj.conditionalFieldId = obj.conditionalFieldId
              found = true
            }
          }
        }
      }
    },
    validateQuestFlow (reqDef, reqObj, reqDefId) {
      return transport.methods.validateQuestFlow([reqDef], [reqObj], reqDefId)
    },
    getLang (key) {
      return language(this.language, key)
    },
    setDraggableObject (object) {
      this.draggableObject = object
      if (this.draggableObject.children.length > 0) {
        if (this.draggableObject.children[0].id !== this.draggableObject.id) {
          this.draggableObject.children = []
        }
      }
    },
    getDefinitionQuestions () {
      var result = null
      var aliasDefinition = transport.methods.getRequestDefinitionById('appsur_cuestionarios_questalias', [this.definition])
      if (aliasDefinition && aliasDefinition.validation && aliasDefinition.validation.domain) {
        result = aliasDefinition.validation.domain
      }
      return result
    },
    getDefinitionBuilderCode () {
      var result = this.repeatableGroupCode
      if (!result) {
        var authVars = this.authorization.split(' ')
        // Segon paràmetre del bearer token "-" timestamp
        var sha256 = require('js-sha256')
        result = sha256(authVars[1] + '-' + moment().valueOf())
        if (this.definitionBuilder) {
          this.$emit('refreshRepeatableGroupCode', result)
        }
      }
      return result
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    itemClicked (itemIndex) {
      if (this.isActionTask() && !this.isLanguageSelector(event.path)) {
        this.calledTaskIndex = {
          ts: this.getMoment(),
          index: itemIndex
        }
      }
    },
    isActionTask () {
      var result = false
      if ((!this.definition.action || this.definition.action === 'R') && this.definition.task) {
        var numTasks = 0
        for (var i = 0; i < this.definition.task.length && numTasks < 2; i++) {
          var task = this.definition.task[i]
          if (task.type.id === 'button' || task.type.id === 'definition') {
            numTasks += 1
          }
        }
        if (numTasks === 1) {
          result = true
        }
      }
      return result
    },
    isLanguageSelector (pathArr) {
      var result = false
      if (pathArr) {
        for (var i = 0; i < pathArr.length && !result; i++) {
          var path = pathArr[i]
          if (path.className === 'language') {
            result = true
          }
        }
      }
      return result
    },
    editingQuestion (editingQuestion) {
      this.$emit('editingQuestion', editingQuestion)
    },
    getRepeatableGroupModeView (object) {
      let result
      if (object && object.editable === false) {
        result = 'lookup'
      } else {
        result = this.modeView
      }
      return result
    },
    formAddSaved (repeatableGroupCode, repeatableId, repeatableGroupObjectFound) {
      this.$emit('formAddSaved', repeatableGroupCode, repeatableId, repeatableGroupObjectFound)
    }
  },
  watch: {
    languageSelected (languageSelected) {
      this.languageChanged = true
      var self = this
      setTimeout(function () {
        self.languageChanged = false
      }, 550)
    },
    object (object) {
      this.setDraggableObject(object)
    },
    draggableObject: {
      handler: function (newVal, oldVal) {
        if (oldVal) {
          this.repeatableGroupOpen = true
        }
      },
      deep: true
    },
    definition (definition) {
      if (!this.modify) {
        this.initRepeatableGroup()
      }
    },
    formAddRemoved: {
      handler: function (newVal, oldVal) {
        if (newVal.id === this.definition.id && newVal.removed) {
          // console.log(this.removeIndex, this.draggableObject.children)
          // this.draggableObject.children.splice(this.removeIndex, 1)
          this.resetModify(true, false)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.repeatable {
  float: left;
  width: 100%;
  padding: 0 15px 0;

  .list-complete-item {
    .edit-hide {
      display: none;
    }
  }

  .fade-modify-container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background-color: rgba(120,120,120,0.76);
  }

  .toggle_accordion {
    cursor: pointer;
    text-align: left;
    font-size: 16px;
    color: #4599a4;
    margin-top: 8px;
    margin-bottom: 4px;

    i.icon_toggle {
      color: #d42e12;
      transition: transform .2s;
      -webkit-transform-: .2s;
      font-size: 19px;
      vertical-align: top;
    }
    i.icon_toggle.rotate180 {
      transform: rotate(180deg);
    }
    i {
      font-size: 14px;

      &:before {
        font-weight: 900;
      }
    }
    > span {
      vertical-align: text-bottom;
      font-family: "Source Sans Pro", sans-serif;
      font-weight: 500;
      color: #aeaeae;
      font-size: 15px;
    }
  }
  .w3-display-container.w3-col.sortable {
    padding: 0 0 15px !important;
    cursor: all-scroll;
  }
  .w3-display-container.sortable {
    padding: 0 20px 15px !important;
  }
  .language .multiselect__tags,
  .language .multiselect__single {
    background-color: #efefef;
  }
  .definitionObj.group {
    .definition-wrapper.group {
      min-height: 80px !important;
      background-color: transparent !important;
    }
  }
}
.repeatableGroupIcon {
  display: inline-block;
  font-size: 13px;
}
.repeatable.repeatableGroupWithIcon {
  display: table;
  width: 100%;
  margin-bottom: 15px;

  .repeatableGroupIcon,
  .repeatableGroupWithIcon {
    vertical-align: middle;
    display: table-cell;
  }
  .repeatableGroupIcon {
    font-size: 35px;
    position: absolute;
    top: 8px;
  }
  .repeatableGroupWithIcon {
    padding: 0;

    .list-complete-item {
      border: 0;
      border-radius: 0;
      margin: 0;
      border-bottom: 5px solid #efefef;
    }
  }
}
.noElements {
  padding: 0 15px;
  margin: 3px 0;
  font-style: italic;
  float: left;
}
.draggable {
  padding: 0 0;
  margin-top: 15px;
  float: inherit;
  width: 100%;
}
.list-complete-item {
  background-color:#ffffff;
  transition: background-color 0.3s;
  transition-timing-function: cubic-bezier(.16,1.03,.41,.82);
  padding:50px 20px 15px;
  margin:0 5px 25px;
  height: 140px;
  float: left;
  line-height: 1.1;

  & > .groupTasks {
    width: 100%;
  }

  &.modifying {
    height: initial !important;
  }

  &.disabled {
    opacity: 0.35;
  }

  &.action-task {
    cursor: pointer;
  }

  .items-scrollbar {
    max-height: 850px;
    overflow-y: auto;
    float: left;
    padding: 10px 20px 20px;
    width: 100%;
  }
  .items-scrollbar::-webkit-scrollbar {
    width: 10px;
    background-color: #dfdfdf;
    border-radius: 10px;
  }
  .items-scrollbar::-webkit-scrollbar-track {
    border-radius: 10px;
    background: rgba(0,0,0,0.3);
    border: 1px solid #bbb;
  }
  .items-scrollbar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: linear-gradient(to right, #fff, #efefef);
    border: 1px solid #aaa;
  }
  .items-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #fff;
  }
  .items-scrollbar::-webkit-scrollbar-thumb:active {
    background: linear-gradient(to right, #22ADD4, #1E98BA);
  }

  .subitem {
    border-radius: 6px;
    transition: background-color 0.4s;

    &.w3-half {
      padding: 5px 25px 5px 0px;
    }

    .read-only {
      padding-top: 5px;

      i {
        vertical-align: middle;
      }
    }

    .w3-col.image {
      border: 1px solid #e0e0e0;
      padding: 5px;
      text-align: center;
      min-height: 432px;
    }
  }

  .subitem.pulse label {
    transition: background-color 0.5s;
    background-color: rgba(93,190,203,0.2);
  }

  .code {
    padding: 8px 0 0 15px;
    font-family: "Source Sans Pro", sans-serif;
    color: #555;
    font-size: 17px;
    font-weight: 600;
    z-index: 10;
    float: left;
    position: relative;

    /* These are technically the same, but use both */
    overflow-wrap: break-word;
    word-wrap: break-word;

    -ms-word-break: break-all;
    /* This is the dangerous one in WebKit, as it breaks things wherever */
    word-break: break-all;
    /* Instead use this non-standard one: */
    word-break: break-word;

    /* Adds a hyphen where the word breaks, if supported (No Blink) */
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;

    .code-value {
      display: none;
    }
  }

  .language-buttons {
    float: right;

    .codeLoading {
      margin-top: 8px;
      float: right;
      width: 40px;
    }
  }

  .buttons {
    z-index: 1;
    background-color: #fbfbfb;
    padding: 0;
    border-bottom: 1px solid #e0e0e0;
    float: left;
    width: 100%;
    height: 35px;

    .language {
      float: right;
      width: 81px;

      .multiselect__tags {
        border: 0;
      }
    }

    .translate {
      display: none;
    }

    &.modify {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 62px;
      background-color: #000;
      z-index: 0;
      top: inherit;
      border: 0;
      border-radius: 0;

      .code {
        padding-top: 19px;
        font-weight: 600;
      }
    }
  }

  .complete-item {
    position: relative;
    display: inline-block;
    width: 100%;
    padding: 45px 15px 0;
  }

  .groupTasks {
    padding: 0;
    position: relative;
    background-color: #f6f6f6;
    margin-top: 10px;
    position: absolute;
    bottom: 15px;
    right: 15px;
    left: 15px;
    padding: 10px;
    border: 1px solid #dfdfdf;
    width: initial;

    .taskEval {
      .taskLabel {
        display: none;
      }
    }

    &.w3-col {
      padding: 8px 0;
    }
  }

  .slot {
    float: left;
    width: auto;
    padding-bottom: 255px;
    padding-left: 10px;

    .inner-slot {
      padding-bottom: 300px;
      float: left;
      width: 100%;
    }

    .groupTasks {
      position: relative;
      background-color: transparent;
      border: 0;
      top: 0;
    }
  }

  label {
    margin-right: 5px;
  }
}
button.remove-item,
button.modify-item {
  padding: 7px 5px 0 0;
  background-color: transparent;
  border: 0;
  float: right;
  cursor: pointer;

  span {
    font-family: "Source Sans Pro", sans-serif !important;
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;

    i {
      color: #ff7643;
    }
  }

  &.ok {
    padding: 0 20px;
    height: 40px;
    float: right;
    margin-right: 20px;
    margin-top: 11px;

    span {
      font-size: 20px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      font-weight: 600;
    }
  }

  &.cancel {
    padding: 0;
    margin: 6px 2px 0 0;

    i {
      color: #d42e12;
      font-size: 15px;
    }
  }

  &.ok {
    background-color: #d42e12;

    span {
      i {
        color: #000;
        font-size: 17px;
      }
    }
  }
}

button.remove-item:hover,
button.modify-item:hover,
button.modify-item.cancel:hover,
button.modify-item.ok:hover {
  span {
    i {
      color: #d42e12;
      transition: all 0.2s ease-in;
    }
  }
}

button:focus {
  outline: 0;
}
.list-complete-item {
  .sortable {
    cursor:all-scroll;
  }
  .sortable:hover {
    background-color:#dbebee;
  }
}
.timeline {
  margin: 10px 0 !important;
  padding: 20px 22px !important;
  --timelineTheme: none !important;
}
.w3-col.w3-quarter-margin {
  width: calc(24.99999% - 10px);
  margin-left: 5px;
  margin-right: 5px;
  overflow: hidden;

  &.lower-min-height {
    min-height: 170px;
  }

  .item {
    padding: 0 0 22px;

    .definitionObj {
      padding: 0 0 22px;
    }
  }
}
.w3-col.w3-half-margin {
  width: calc(49.99999% - 10px);
  margin-left: 5px;
  margin-right: 5px;
  overflow: hidden;
}
.w3-height-1200 {
  height: 1200px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-900 {
  height: 900px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-840 {
  height: 840px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-700 {
  height: 700px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-600 {
  height: 600px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-500 {
  height: 500px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-400 {
  height: 400px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-375 {
  height: 375px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-350 {
  height: 350px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-325 {
  height: 325px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-300 {
  height: 300px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-col.w3-height-200 {
  height: 200px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-200 {
  height: 200px !important;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-col.w3-height-180 {
  height: 180px;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-180 {
  height: 180px !important;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-130 {
  height: 130px !important;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-150 {
  height: 150px !important;
  .items-scrollbar {
    padding-bottom: 10px;
  }
}
.w3-height-110 {
  height: 110px !important;
}
.w3-display-container.w3-col.w3-height-110.sortable {
  height: 110px;
  padding-top: 20px !important;

  .items-scrollbar {
    padding-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/repeatableGroup/index.vue